<section>
  <app-form-header></app-form-header>
  <app-information-block class="send-tenant-sms-form__help-block astral-content-width" [text]="'SMS_LIST.INFORMATION' | translate"></app-information-block>
  @if (form && hasRecipients) {
    <form class="send-tenant-sms-form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-textarea [control]="form.controls['message']" [rows]="14"></astral-textarea>
      </section>
      @if (showRecipients && recipients.length) {
        <section class="astral-section-surface astral-stack-s">
          <h4 class="send-tenant-sms-form__section-title">{{ 'MULTI_TENANT_FORM.RECIPIENT_HEADER' | translate }}</h4>
          <div class="send-tenant-sms-form__recipient-list astral-stack-s">
            @for (recipient of recipients; track recipient) {
              <astral-input
                [label]="'MAIL_FORM.SMS_RECIPIENT_DESCRIPTION' | translate"
                [value]="recipient.recipientName"
                [readonly]="true"
              ></astral-input>
            }
          </div>
        </section>
      }
      <div class="astral-form-actions">
        <astral-button type="button" variant="primary" labelKey="SEND_BTN" [disabled]="isSendDisabled" (click)="send()"></astral-button>
        <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  }
</section>
